import { gql } from '@apollo/client';

export const GET_USER_PROFILE_DATA = gql`
  query GetUserData($userId: ID!) {
    user(id: $userId) {
      id
      username
      email
      passwordHash
      role
      profilePicture
      phoneNumber
      status
      lastLogin
      twoFactorEnabled
      gender
      createdAt
      updatedAt
    }
    addresses(userId: $userId) {
      id
      city
      state
      country
      isDefault
      postalCode
      addressLine1
      addressLine2
      userId
    }
    getOrders(userId: $userId) {
      id
      totalAmount
      status
      createdAt
    }
    getTransactions(userId: $userId) {
      id
      amount
      createdAt
    }
  }
`;
